import { pushRoute } from '../../lib/router.js';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Empty from '../../components/Empty.jsx';
import { loadingContent } from '../../components/EmptyStates.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import {
  retrieveChangeImpactTypes,
  selectChangeImpactTypes,
  selectRetrieveChangeImpactTypesState,
} from '../../modules/changeImpactTypes.js';
import {
  retrieveTemplatesFeedbackForm,
  selectRetrieveTemplatesState,
  selectTemplates,
} from '../../modules/changeInsights.js';
import { INITIATIVE_TYPES } from '../../lib/schema.js';
import {
  selectOrganization,
  selectRetrieveOrganizationState,
} from '../../modules/organizations.js';
import SubHeader from '../../components/SubHeader.jsx';
import OrganizationHeader from '../../components/headers/PageHeaders/Organization/OrganizationHeader.jsx';
import {
  retrieveInitiativeCategories,
  selectInitiativeCategories,
  selectRetrieveInitiativeCategoriesState,
} from '../../modules/initiativeCategories.js';
import InitiativeCategoryFromContainer from '../initiatives/InitiativeCategoryFromContainer.jsx';
import {
  retrieveProjectStatuses,
  selectProjectStatuses,
  selectRetrieveStatusesState,
} from '../../modules/projectStatuses.js';
import AccordionSection from '../../components/organizations/AccordionSection.jsx';
import { selectUserPermissions } from '../../modules/auth.js';
import { isAuthorized } from '../../components/AuthorizedAction.js';
import ChangeInsightTemplatesAccordion from '../../components/organizations/Settings/ChangeInsightTemplates/ChangeInsightTemplatesAccordion/ChangeInsightTemplatesAccordion.jsx';
import CompanySettingsAccordion from '../../components/organizations/Settings/CompanySettings/CompanySettingsAccordion/CompanySettingsAccordion.jsx';

const mapStateToProps = (state) => {
  const retrieveSuccess = [
    selectRetrieveInitiativeCategoriesState,
    selectRetrieveStatusesState,
    selectRetrieveTemplatesState,
    selectRetrieveChangeImpactTypesState,
  ].every((select) => select(state).success);

  return {
    retrieveSuccess,
    organization: selectOrganization(state),
    retrieveError: selectRetrieveOrganizationState(state).error,
    initiativeCategories: selectInitiativeCategories(state),
    customProjectStatuses: selectProjectStatuses(state),
    changeImpactTypes: selectChangeImpactTypes(state),
    changeInsights: selectTemplates(state),
    permissions: selectUserPermissions(state),
  };
};

const mapDispatchToProps = {
  retrieveInitiativeCategories,
  retrieveProjectStatuses,
  retrieveTemplatesFeedbackForm,
  retrieveChangeImpactTypes,
};

const OrganizationSettingsContainer = (props) => {
  const {
    initiativeCategories,
    organization,
    customProjectStatuses,
    changeInsights,
    changeImpactTypes,
    permissions,
    retrieveProjectStatuses,
    retrieveSuccess,
    retrieveTemplatesFeedbackForm,
    retrieveInitiativeCategories,
    retrieveChangeImpactTypes,
  } = props;
  const [showInitiativeCategoryModal, setShowInitiativeCategoryModal] =
    useState(false);
  const [initiativeType, setInitiativeType] = useState('');
  const [selectedCategoryId, updateSelectedCategoryId] = useState('');

  const onHideInitiativeCategoryModal = () => {
    setInitiativeType('');
    updateSelectedCategoryId('');
    setShowInitiativeCategoryModal(false);
  };
  const handleClickEditStatuses = () =>
    pushRoute('organization/custom-settings/statuses/edit');
  const handleClickEditCategories = () =>
    pushRoute('organization/custom-settings/categories/edit');
  const handleClickEditChangeImpactTypes = () =>
    pushRoute('organization/custom-settings/change-impact-types/edit');
  const handleClickAddTemplate = () =>
    pushRoute('organization/custom-settings/change-insights/new');
  const handleClickEditCompanySettings = () =>
    pushRoute('organization/custom-settings/organization-settings/edit');

  useEffect(() => {
    retrieveInitiativeCategories();
    retrieveProjectStatuses();
    retrieveTemplatesFeedbackForm();
    retrieveChangeImpactTypes();
  }, []);
  const checkAuthorize = isAuthorized('update', 'surveyTemplate', permissions);

  const checkAuthorizeCustomSettings =
    isAuthorized('update', 'dynamicCategory', permissions) ||
    isAuthorized('read', 'projectStatus', permissions) ||
    isAuthorized('read', 'initiativeCategory', permissions);

  return (
    <React.Fragment>
      <OrganizationHeader organizationTabs />
      <SubHeader flex flexJustify>
        <h2>Custom Settings</h2>
      </SubHeader>
      {retrieveSuccess ? (
        <React.Fragment>
          {checkAuthorize ? (
            <CompanySettingsAccordion
              type="Organization Settings"
              data={{ name: 'CompanyNameMock' }}
              onEdit={handleClickEditCompanySettings}
              permissions={permissions}
              checkAuthorizeCustomSettings={checkAuthorizeCustomSettings}
            />
          ) : null}

          {checkAuthorizeCustomSettings ? (
            <AccordionSection
              type={getOrgTermsContent('projectStatuses')}
              items={customProjectStatuses}
              onEdit={handleClickEditStatuses}
              permissions={permissions}
              checkAuthorizeCustomSettings={checkAuthorizeCustomSettings}
              max={10}
              tooltipTitle={`${getOrgTermsContent('project')} And ${getOrgTermsContent('portfolio')} Statuses`}
              title={`${getOrgTermsContent('project')} And ${getOrgTermsContent('portfolio')} Statuses`}
              tooltipContent={getOrgTermsContent('projectStatusesTooltip')}
            />
          ) : null}
          {checkAuthorizeCustomSettings ? (
            <AccordionSection
              type={getOrgTermsContent('initiativeCategories')}
              items={initiativeCategories}
              permissions={permissions}
              childItems={INITIATIVE_TYPES}
              checkAuthorizeCustomSettings={checkAuthorizeCustomSettings}
              onEdit={handleClickEditCategories}
              tooltipTitle={`${getOrgTermsContent('initiative')} Categories`}
              tooltipContent={getOrgTermsContent('initiativeCategoriesTooltip')}
            />
          ) : null}

          {checkAuthorizeCustomSettings ? (
            <AccordionSection
              type="Change Impact Types"
              items={changeImpactTypes}
              permissions={permissions}
              checkAuthorizeCustomSettings={checkAuthorizeCustomSettings}
              max={15}
              firstColumn="Projects"
              secondColumn="Change Impacts"
              tooltipTitle="Change Impact Types"
              tooltipContent={getOrgTermsContent('changeImpactsLimitMess')}
              onEdit={handleClickEditChangeImpactTypes}
            />
          ) : null}

          {changeInsights && permissions ? (
            <ChangeInsightTemplatesAccordion
              type="ChangeInsights Hub"
              items={changeInsights.sort((a, b) =>
                a.title.localeCompare(b.title)
              )}
              permissions={permissions}
              organization={organization}
              tooltipContent={getOrgTermsContent('surveyTemplateTooltip')}
              onAdd={handleClickAddTemplate}
            />
          ) : null}
        </React.Fragment>
      ) : (
        <Empty simplified content={loadingContent} />
      )}
      <InitiativeCategoryFromContainer
        showFormModal={showInitiativeCategoryModal}
        onHideFormModal={onHideInitiativeCategoryModal}
        initiativeType={initiativeType}
        categoryId={selectedCategoryId}
      />
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationSettingsContainer);
